import { render, staticRenderFns } from "./EditMovementAdjustments.vue?vue&type=template&id=2a0444fb"
import script from "./EditMovementAdjustments.vue?vue&type=script&lang=js"
export * from "./EditMovementAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports